<template>
  <div class="font-semibold text-gray-700">
    {{ $t('settings.calendar.embed_code') }}
  </div>
  <div class="py-2 text-sm text-gray-500">
    {{ $t('settings.calendar.share_embed_code', { embedType: embedType }) }}
  </div>
  <div class="code-block-font my-4 rounded-lg bg-blue-50 p-6 text-green-700">
    {{ embedCodeForCalendar }}
  </div>
  <UIButton
    id="copyEmbedCodeButton"
    class="float-right mt-4 w-1/5"
    type="primary"
    size="small"
    @click="copyScript"
    :disabled="data?.isSaving"
    ><Copy01Icon class="mr-2 h-4 w-4" /> {{ $t('settings.calendar.copy') }}
  </UIButton>
</template>

<script setup lang="ts">
import { Copy01Icon } from '@gohighlevel/ghl-icons/24/outline'
import { UIButton, useNotification } from '@gohighlevel/ghl-ui'
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { WidgetType } from '../../../models/calendar'
import AppState from '../../../states/app'
import { ICalendarShare, SHARE_SOURCE } from '../../../types'
import { copyToClipboard } from '../../../utils/generalFunctions'
const notification = useNotification()
const { t } = useI18n()

const props = defineProps({
  data: {
    type: Object as PropType<ICalendarShare>,
    default: null,
  },
})

const embedType = computed(() => {
  return props.data?.source === SHARE_SOURCE.CALENDAR ? 'calendar' : 'group'
})

const embedCodeForCalendar = computed(() => {
  const embedScript =
    props.data?.widgetType === WidgetType.CLASSIC &&
    props.data?.source === SHARE_SOURCE.CALENDAR
      ? 'embed.js'
      : 'form_embed.js'

  const uniqueId = `${
    props.data?.providerId ? props.data?.providerId : props.data?.id
  }_${new Date().getTime()}`

  const iframeId =
    props.data?.widgetType === WidgetType.CLASSIC
      ? 'msgsndr-calendar'
      : uniqueId
  return `<iframe src="${AppState?.baseUrl}/widget/${props.data?.permanentPath}/${props.data?.id}" style="width: 100%;border:none;overflow: hidden;" scrolling="no" id="${iframeId}"><\/iframe><br><script src="${AppState.embedUrl}/${embedScript}" type="text/javascript"><\/script>`
})

const copyScript = () => {
  copyToClipboard(embedCodeForCalendar.value)
  notification.info({
    content: t('settings.calendar.copied_to_clipboard'),
    duration: 1 * 1000,
  })
}
</script>

<style scoped>
.code-block-font {
  font-family: 'Roboto Mono';
}
</style>
